export default "__VITE_ASSET__P65HvZA2__"